import { connectionStore, STR_ERRORS } from "../../";
export function applyRESTQueries(connection, m) {
    const c = connectionStore.get(connection);
    if (!c) {
        return Promise.reject(STR_ERRORS.NoConnectionsAvailable);
    }
    return c.send(m);
}
//# sourceMappingURL=ApplyRESTQueries.js.map